
export enum FrequencyType {
  Builder,
  Product
}

export class Frequency {

  count: number;
  label: string;
  score: number;
  percentageString: string;

  constructor(public data: any, type: FrequencyType) {
    const json: JSON = data;

    // JSON struction for Builder ratings
    if (type === FrequencyType.Builder) {
      this.count = json['frequency'];
      this.label = json['qlabel'];
      this.score = json['score'];
    }

    // JSON struction for Product ratings
    if (type === FrequencyType.Product) {
      this.count = json['ratingsCount'];
      this.score = json['starRating'];
    }
  }
}

/*

 "frequency": [
 {
 "frequency": 23,
 "qlabel": "Overall Rating",
 "score": 6
 },
 {
 "frequency": 11,
 "qlabel": "Overall Rating",
 "score": 5
 },
 {
 "frequency": 1,
 "qlabel": "Overall Rating",
 "score": 4
 },
 {
 "frequency": 0,
 "qlabel": "Overall Rating",
 "score": 3
 },
 {
 "frequency": 0,
 "qlabel": "Overall Rating",
 "score": 2
 },
 {
 "frequency": 0,
 "qlabel": "Overall Rating",
 "score": 1
 }
 ],
 */



// WEBPACK FOOTER //
// ./src/app/model/frequency.ts